import Presenter from './Presenter';
import { IContainerProps } from './types';

const LoginContainer = (props: IContainerProps) => {

    return (
        <Presenter
            {...props}
        />
    );
};

export default LoginContainer;
